// ----------------------------------------------------------------------
// <copyright file="Izenda.Connections.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var ConnectionDetail = require('./Izenda.ConnectionDetail');
  var m = require('mobx');
  const { map } = require('lodash/fp');
  function Connections() {
    var props = {
      item: new ConnectionDetail(),
      list: [],
      filter: '',
      dbTypeList: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Set new filter value for connection list.
   * @param {string} newFilter Searching text
   */
  Connections.prototype.setFilter = function(newFilter) {
    this.filter = newFilter || '';
  };

  /**
   * Read connection list and map connection data to connection detail instance.
   * That keeps all item in list will be instance of connection detail. It also
   * updates the observable connection list, then the UI will be updated accordingly.
   * @param  {Array} connList Array of connection list that returned from API
   */
  Connections.prototype.readConnectionList = m.action(function(connList) {
    // Populate connection detail item instance from its data
    var createConnectionDetail = function(itemData) {
      var item = new ConnectionDetail();
      item.readDetail(itemData);
      return item;
    };

    // Clean current list and append new connection list
    this.list.replace(map(createConnectionDetail, connList));
  });

  /**
   * Read database type list. It provides list of db type options to connection
   * detail UI. It will reload full database type list in current store.
   * @param  {Array} dbTypeList The database type list that returns from API
   */
  Connections.prototype.readDbTypeList = m.action(function(dbTypeList) {
    // Clean current list and append new database type list
    this.dbTypeList.replace(dbTypeList);
  });

  /**
   * Add new connection and mark it as selected item.
   */
  Connections.prototype.addConnection = m.action(function(id) {
    this.item = new ConnectionDetail();
    this.item.id = id;

    return Promise.resolve(this.item);
  });

  module.exports = Connections;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Connections.js